module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "level1 hidden",
    attrs: {
      "data-number": "2",
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('h1', {
    staticClass: "hidden",
    attrs: {
      "data-number": "2",
      "epub:type": "epigraph"
    }
  }, [_vm._v("Epigraph")]), _vm._v(" "), _c('blockquote', {
    staticClass: "hanging_indent"
  }, [_c('p', [_vm._v("Into this Universe, and "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("why")]), _vm._v(" not knowing,")]), _vm._v(" "), _c('p', [_vm._v("Nor "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("whence")]), _vm._v(", like Water willy-nilly flowing;")]), _vm._v(" "), _c('p', [_vm._v("And out of it, as Wind along the Waste,")]), _vm._v(" "), _c('p', [_vm._v("I know not "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("whither")]), _vm._v(", willy-nilly blowing.")])]), _vm._v(" "), _c('p', {
    staticClass: "right_align"
  }, [_vm._v("From "), _c('em', [_vm._v("The Rubaiyyat of Omar Kayaam")])]), _vm._v(" "), _c('p', {
    staticClass: "right_align"
  }, [_vm._v("Translated by Edward Fitzgerald")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bccb5d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0